/* Per-month Visit / Token / Booking targets.
 *
 * Employee.visitTarget/tokenTarget/bookingTarget hold one figure with no
 * time dimension, so a target set in April was still the target in
 * September. The performance_targets table gives each employee a row per
 * month; those old columns are now dead weight, still written by
 * employeeUiToApi but read by nothing.
 *
 * A month with no row means NO TARGET SET, not a target of zero -- the
 * caller decides how to render that. */
import { api } from "./api";

const BASE = "/performance-targets";

export const performanceTargetsApi = {
  /** All employees' targets for one "YYYY-MM". Returns a { [employeeId]: {...} } map. */
  async listByMonth(month) {
    if (!month) return {};
    const rows = await api.get(`${BASE}?month=${encodeURIComponent(month)}`);
    const out = {};
    for (const r of rows || []) {
      out[r.employeeId] = {
        visitTarget: r.visitTarget ?? 0,
        tokenTarget: r.tokenTarget ?? 0,
        bookingTarget: r.bookingTarget ?? 0,
      };
    }
    return out;
  },

  /** Upsert one employee's targets for one month. The API merges, so a
   *  partial payload leaves the other two alone. */
  async upsert(employeeId, month, targets) {
    return api.patch(`${BASE}/${encodeURIComponent(employeeId)}`, {
      month,
      ...targets,
    });
  },
};
